/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkplacePreference = {
    Onsite: 'ONSITE',
    Remote: 'REMOTE'
} as const;
export type WorkplacePreference = typeof WorkplacePreference[keyof typeof WorkplacePreference];


export function instanceOfWorkplacePreference(value: any): boolean {
    for (const key in WorkplacePreference) {
        if (Object.prototype.hasOwnProperty.call(WorkplacePreference, key)) {
            // @ts-ignore
            if (WorkplacePreference[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkplacePreferenceFromJSON(json: any): WorkplacePreference {
    return WorkplacePreferenceFromJSONTyped(json, false);
}

export function WorkplacePreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkplacePreference {
    return json as WorkplacePreference;
}

export function WorkplacePreferenceToJSON(value?: WorkplacePreference | null): any {
    return value as any;
}

